import styled from 'styled-components';

export const EditETACheckoutStyled = styled.div`
  min-height: 84vh;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
